import {populateComments} from "./populateComments";
export function showComments(id, count, tmpCommunityType) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_comments",
        datatype: "json",
        data: {
            "ajax_call_id": id,
            "ajax_call_count": count,
            "ajax_call_shown_comments": shownComments[id],
            "ajax_call_community_type": tmpCommunityType,
            "ajax_call_community_type_list": communityType
        },
        success: function (output) {
            populateComments(id, output, tmpCommunityType);
        }
    });
}